export default "__VITE_ASSET__cd6a4c22__"